import PhoneIcon from '@mui/icons-material/Phone';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

import CallbackModal from './CallbackModal';
import SupportModal from './SupportModal';
import { trackEvent } from '../modules/matomo';

const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1),
  width: '100%',
  a: {
    textDecoration: 'none',
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    '&:hover, &:focus-visible': {
      textDecoration: 'underline',
    },
  },
  '.contact': {
    display: 'none',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '0.8rem',
    gap: theme.spacing(2),
  },
  '.icons': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '.MuiIconButton-root': {
      fontSize: '1.75rem',
      marginLeft: theme.spacing(2),
    },
  },
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    justifyContent: 'center',
    gap: theme.spacing(4),
    a: {
      fontSize: '1.3rem',
    },
    '.contact': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: theme.spacing(0),
    },
    '.icons': {
      // display: 'flex',
      // flexDirection: 'row',
      // alignItems: 'center',
      '.MuiIconButton-root': {
        fontSize: '3rem',
      },
    },
  },
  '@media (max-width: 480px) and (max-height: 480px)': {
    padding: 0,
    '.icons .MuiIconButton-root': {
      marginLeft: theme.spacing(0.5),
      padding: theme.spacing(0.75),
    },
  },
}));

const Contact = () => {
  const [openCallbackModal, setOpenCallbackModal] = React.useState(false);
  const [openSupportModal, setOpenSupportModal] = React.useState(false);

  const handleOpenCallbackModal = () => {
    setOpenCallbackModal(true);
    trackEvent('Callback', 'Dialog Öffnen', 'Header');
  };
  const handleCloseCallbackModal = () => setOpenCallbackModal(false);
  const handleOpenSupportModal = () => {
    setOpenSupportModal(true);
    trackEvent('Support', 'Dialog Öffnen', 'Header');
  };
  const handleCloseSupportModal = () => setOpenSupportModal(false);

  return (
    <StyledContainer>
      <Box className="contact">
        <a href="tel:+49611300299" onClick={() => trackEvent('Telefon', 'Click', 'Header')}>+49 (0) 611 300 299</a>
        <a href="mailto:mail@mymk.de" onClick={() => trackEvent('Email', 'Click', 'Header')}>mail@mymk.de</a>
      </Box>
      <Box className="icons">
        <Tooltip title="Rückruf veranlassen">
          <IconButton
            aria-label="Rückruf veranlassen"
            className="borderBox"
            color="inherit"
            onClick={handleOpenCallbackModal}
          >
            <PhoneIcon fontSize='inherit' />
          </IconButton>
        </Tooltip>
        <CallbackModal open={openCallbackModal} onClose={handleCloseCallbackModal} />
        <Tooltip title="Teamviewer Support">
          <IconButton
            aria-label="TeamViewer-Support öffnen"
            className="borderBox"
            color="inherit"
            onClick={handleOpenSupportModal}
          >
            <SupportAgentIcon fontSize='inherit' />
          </IconButton>
        </Tooltip>
        <SupportModal open={openSupportModal} onClose={handleCloseSupportModal} />
      </Box>
    </StyledContainer>
  );
};

export default Contact;
